import { companyStatus } from '../model/types';

// Maps a `crm.company.companyStatus` value to a shared/ui Badge variant.
// Used by the accounts list (own row) and the contacts list (joined
// company status) so both surfaces render the same colour scheme.
export const statusBadgeVariant = (
  status: string | null | undefined
): 'active' | 'inactive' | 'error' | 'pending' => {
  if (status === companyStatus.ACTIVE) return 'active';
  if (status === companyStatus.BLACKLISTED) return 'error';
  if (status === companyStatus.DELETED) return 'pending';
  if (status === companyStatus.INACTIVE) return 'inactive';
  // Archived reads as dormant-but-intact, same as Inactive — 'pending' is
  // already taken by Deleted.
  if (status === companyStatus.ARCHIVED) return 'inactive';
  return 'inactive';
};
